// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1DzFI","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2mxeD"};